import * as React from 'react';
import { useWindowSize } from './hooks';
import { WindowSizeContext } from './context';

interface IWindowSizeProvider {
    children?: React.ReactNode;
}

export function WindowSizeProvider(props: IWindowSizeProvider) {
    const { children } = props;
    const size = useWindowSize();
    return (
        <WindowSizeContext.Provider value={size}>
            {children}
        </WindowSizeContext.Provider>
    );
}
